const MASS = 'MASS';
const VOLUME = 'VOLUME';
const INDICATOR_TYPES = ['flowMetersOnly', 'ppm'];
const INJECTION_CONTROLS = ['proportionalFeed', 'slugDosage'];
const MAKEUP_PERCENTAGE = 'MAKEUP_PERCENTAGE';
const CYCLES_OF_CONCENTRATION = 'CYCLES_OF_CONCENTRATION';
const NONE = 'NONE';
const BOILER_RATED_CAPACITY_UNITS = ['HP', 'lb/hr', 't/hr', 'ut/hr', 'kg/hr', 'Btu/hr'];

const WATER_SAVINGS_UNITS = ['m3', 'l', 'ig', 'usg', 'ft3'];
const ENERGY_SAVINGS_UNITS = ['TJ', 'GJ', 'MJ', 'kWh', 'mmBtu', 'Therm'];
const CO2_EMISSIONS_UNITS = ['lb', 'kg', 't', 'ut']; // t for metric ton and T for US tonnes

const FEED_WATER_TEMPERATURE_UNITS = ['F', 'C'];
const OPERATING_PRESSURE_UNITS = ['psi', 'bar'];
const SIMPLIFIED = 'simplified';

const COMBUSTILES_LISTS = ['solidFossil', 'liquidFossil', 'gasFossil', 'biomass', 'electricity'];
const FUELNAMES = {
    solidFossil: [
        'anthracite', 'bitumen', 'brownCoalBriquettes', 'coalTar',
        'cokeOvenCoke', 'cokingCoal', 'gasCoke', 'lignite', 'ligniteCoke',
        'municipalWasteNonBiomassFraction', 'otherBituminousCoal', 'paraffinWaxes',
        'patentFuel', 'petroleumCoke', 'subBituminousCoal',
    ],
    liquidFossil: [
        'aviationGasoline', 'crudeOil', 'ethane', 'gasDieselOil', 'jetGasoline',
        'jetKerosene', 'liquifiedPetroleumGases', 'lubricants', 'motorGasoline', 'naphtha',
        'naturalGasLiquids', 'oilShaleAndTarSands', 'orimulsion', 'otherKerosene',
        'refineryFeedstocks', 'refineryGas', 'residualFuelOil', 'shaleOil', 'wasteOils',
        'whiteSpiritSBP',
    ],
    gasFossil: [
        'blastFurnaceGas', 'cokeOvenGas', 'gasWorksGas', 'naturalGas',
        'oxygenSteelFurnaceGas',
    ],
    biomass: [
        'biodiesels', 'biogasoline', 'charcoal', 'landfillGas',
        'municipalWastesBiomassFraction', 'otherBiogas', 'otherLiquidBiofuels',
        'otherPrimarySolidBiomassFuels', 'peat', 'sludgeGas',
        'sulphiteLyesBlackLiquor', 'woodOrWoodWaste',
    ],
    electricity: [
        'US-asccAlaskaGrid',
        'US-asccMiscellaneous',
        'US-weccSouthwest',
        'US-weccCalifornia',
        'US-ercotAll',
        'US-frccAll',
        'US-hiccMiscellaneous',
        'US-hiccOahu',
        'US-mroEast',
        'US-mroWest',
        'US-npccNewEngland',
        'US-weccNorthwest',
        'US-npccNYCWestchester',
        'US-npccLongIsland',
        'US-npccUpstateNY',
        'US-puertoRicoMiscellaneous',
        'US-rfcEast',
        'US-rfcMichigan',
        'US-rfcWest',
        'US-weccRockies',
        'US-sppNorth',
        'US-sppSouth',
        'US-sercMississippiValley',
        'US-sercMidwest',
        'US-sercSouth',
        'US-sercTennesseeValley',
        'US-sercVirginiaCarolina',
        'CA-newfoundlandAndLabrador',
        'CA-princeEdwardIsland',
        'CA-novaScotia',
        'CA-newBrunswick',
        'CA-quebec',
        'CA-ontario',
        'CA-manitoba',
        'CA-saskatchewan',
        'CA-alberta',
        'CA-britishColumbia',
        'CA-yukon',
        'CA-northwestTerritories',
        'CA-nunavut',
        'Austria',
        'BosniaAndHerzegovina',
        'Belgium',
        'Bulgaria',
        'Switzerland',
        'Cyprus',
        'Czechia',
        'Germany',
        'Denmark',
        'Estonia',
        'Spain',
        'Finland',
        'France',
        'UnitedKingdom',
        'Greece',
        'Croatia',
        'Hungary',
        'Ireland',
        'Iceland',
        'Italy',
        'Lithuania',
        'Luxembourg',
        'Latvia',
        'Montenegro',
        'Malta',
        'Netherlands',
        'Norway',
        'Poland',
        'Portugal',
        'Romania',
        'Serbia',
        'Sweden',
        'Slovenia',
        'Slovakia',
    ],
};

const BIOMASS_UNITS_FOR_FUEL_NAME_EXEPTION = ['landfillGas', 'otherBiogas', 'sludgeGas'];
const CONBUSTIBLES_UNITS = {
    solidFossil: ['t', 'ut', 'lb', 'kg', 'TJ', 'GJ', 'MJ', 'kWh', 'mmBtu', 'Therm'],
    liquidFossil: ['bbl', 'usg', 'ig', 'l', 'TJ', 'GJ', 'MJ', 'kWh', 'mmBtu', 'Therm'],
    gasFossil: ['ft3', 'm3', 'TJ', 'GJ', 'MJ', 'kWh', 'mmBtu', 'Therm'],
    electricity: ['TJ', 'GJ', 'MJ', 'kWh', 'mmBtu', 'Therm'],
    biomass: ['t', 'ut', 'lb', 'kg', 'TJ', 'GJ', 'MJ', 'kWh', 'mmBtu', 'Therm'],
};


const WATER_SAVING_REPORT_UNITS = ['l', 'm3', 'ig', 'usg', 'ft3'];
const ENERGY_SAVINGS_REPORT_UNITS = ['kWh', 'MJ', 'GJ', 'TJ', 'mmBtu', 'Therm'];
const CO2_EMISSIONS_REPORT_UNITS = ['kg', 'lb', 't', 'ut'];

const BASELINE_DATA_PERIODS = ['annual', 'semiannual', 'quarterly', 'monthly'];

const E4_FUEL = 'FUEL';
const E4_BOILER = 'BOILER';
const BALANCETYPEENERGY = [E4_FUEL, E4_BOILER];
const DENSITIES_UNITS = ['kg/l', 'kg/m3', 'g/cm3', 'lb/ft3'];
const UNITS_WITH_DENTISITY = ['bbl', 'usg', 'ig', 'l', 'ft3', 'm3'];
const WATER_SAVINGS_BASELINE_OPTIONS = ['makeUpAndCycles', 'blowdownAndCycles', 'makeUpAndBlowdown'];

const NB_PER_LITER = {
    m3: 0.001,
    l: 1,
    ig: 0.219969,
    usg: 0.264172,
    ft3: 0.0353147,
};

const NB_PER_KG= {
    lb: 2.20462,
    kg: 1,
    t: 0.001,
    ut: 0.00110231,
};

const NB_PER_KWH = {
    kWh: 1,
    MJ: 3.6,
    GJ: 0.0036,
    TJ: 0.0000036,
    mmBtu: 0.003412,
    Therm: 0.0341296,
};


module.exports = {
    MASS,
    VOLUME,
    INDICATOR_TYPES,
    INJECTION_CONTROLS,
    MAKEUP_PERCENTAGE,
    CYCLES_OF_CONCENTRATION,
    NONE,
    SIMPLIFIED,
    BALANCETYPEENERGY,
    E4_FUEL,
    E4_BOILER,
    BOILER_RATED_CAPACITY_UNITS,
    WATER_SAVINGS_UNITS,
    ENERGY_SAVINGS_UNITS,
    CO2_EMISSIONS_UNITS,
    FEED_WATER_TEMPERATURE_UNITS,
    OPERATING_PRESSURE_UNITS,
    COMBUSTILES_LISTS,
    FUELNAMES,
    CONBUSTIBLES_UNITS,
    BASELINE_DATA_PERIODS,
    WATER_SAVING_REPORT_UNITS,
    ENERGY_SAVINGS_REPORT_UNITS,
    CO2_EMISSIONS_REPORT_UNITS,
    DENSITIES_UNITS,
    UNITS_WITH_DENTISITY,
    WATER_SAVINGS_BASELINE_OPTIONS,
    NB_PER_LITER,
    NB_PER_KG,
    NB_PER_KWH,
    BIOMASS_UNITS_FOR_FUEL_NAME_EXEPTION,
};
